var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPublishJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 117,
    viewBox: "0 0 136 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.0625,
    y: 18.832,
    width: 92.8377,
    height: 20.0988,
    rx: 4.6281,
    fill: "#E5E7EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0625,
    y: 44.9297,
    width: 92.8377,
    height: 20.0988,
    rx: 4.6281,
    fill: "#E5E7EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0625,
    y: 71.0273,
    width: 92.8377,
    height: 20.0988,
    rx: 4.6281,
    fill: "#E5E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2812 55.0859L2.09985 63.2673",
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10156 55.0898L10.283 63.2712",
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.898 2.86328L126.43 10.3314",
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.43 2.86719L133.898 10.3353",
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.4492,
    cy: 108.352,
    r: 5.78512,
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPublishJob);
export default __webpack_public_path__ + "static/media/noPublishJob.7c62e552a798e45498b78ae2d883ba5f.svg";
export { ForwardRef as ReactComponent };